import React, { FC, useEffect, useState } from "react";
import { Button, Col, Input, Row, message } from "antd";
import { useParams } from "react-router-dom";

import { IModal } from "@types";
import Modal from "@components/Modal";
import {
  ErrorServices,
  useUpdateCompanySubJobFunctionMutation,
} from "@services";
import { useTypedSelector } from "@/hooks";

export interface IEditJobSubFunction extends IModal {
  jsfItem: { [key: string]: any };
}

const { TextArea } = Input;

const EditCompanyJobSubFunction: FC<IEditJobSubFunction> = ({
  isVisible,
  setIsVisible,
  jsfItem,
  companyId,
}) => {
  const { user } = useTypedSelector(state => state.auth);
  const { job_id } = useParams<{ job_id: string }>();

  const company_job_function_id = Number(job_id);

  const [jobSubFunction, setJobSubFunction] = useState("");
  const [description, setDescription] = useState("");

  const [updateCompanySubJobFunction, { isLoading }] =
    useUpdateCompanySubJobFunctionMutation();

  useEffect(() => {
    setJobSubFunction(jsfItem?.name || "");
    setDescription(jsfItem?.description || "");
  }, [jsfItem]);

  const onSubmit = async () => {
    try {
      const response = await updateCompanySubJobFunction({
        company_id: companyId,
        company_sub_job_function_id: jsfItem?.id,
        name: jobSubFunction,
        description,
        company_job_function_id,
      }).unwrap();

      if (response?.success === false) {
        message.error(
          response?.message || "Unable to update company sub job function"
        );
        return;
      }

      message.success("Job Sub Function successfully updated");
      closeModal();
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const closeModal = () => {
    setIsVisible(false);
    setJobSubFunction("");
    setDescription("");
  };

  return (
    <Modal
      width={544}
      footer={[
        <Button
          disabled={!jobSubFunction.trim() || isLoading}
          onClick={onSubmit}
          key="1"
          type="primary"
          loading={isLoading}
        >
          Update
        </Button>,
        <Button onClick={closeModal} key="2">
          Cancel
        </Button>,
      ]}
      onClose={closeModal}
      title="Update the Job-Sub Function"
      isVisible={isVisible}
    >
      <>
        <Row justify="space-between" className="modal__row">
          <Col span={24}>
            <label>Job-Sub Function</label>
            <Input
              value={jobSubFunction}
              onChange={e => setJobSubFunction(e.target.value)}
              size="large"
              placeholder="Name of the job-sub function here..."
            />
          </Col>
        </Row>

        <Row
          justify="space-between"
          className="modal__row"
          style={{ marginTop: 16 }}
        >
          <Col span={24}>
            <label>Description</label>
            <TextArea
              value={description}
              onChange={e => setDescription(e.target.value)}
              rows={4}
              placeholder="Description here..."
            />
          </Col>
        </Row>
      </>
    </Modal>
  );
};

export default EditCompanyJobSubFunction;
